// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/mission-launch/shared/MissionMetric.jsx

import React from 'react';

export default function MissionMetric({ label, value, detail = '', compact = false, signal = 'neutral' }) {
  return (
    <div className={`mission-metric mission-metric-${signal}${compact ? ' mission-metric-compact' : ''}`}>
      <span className="mission-metric-label">{label}</span>
      <strong>{value}</strong>
      {detail ? <span className="mission-metric-detail">{detail}</span> : null}
    </div>
  );
}
